import { createGLBModel } from "./GLBModel";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

import suzanneUrl from "../../../../assets/models/suzanne.glb";

const SuzanneModel = createGLBModel({
  id: "suzanne",

  name: "Suzanne",

  url: suzanneUrl,

  transform: {
    scale: 1.4,

    rotation: [-Math.PI / 2, 0, 0],
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },

  geometryProcessor: computeCurvatureDirections,
});

export default SuzanneModel;
